(() => {
    const buttonWrapper = document.querySelector('[menu="customer-account-main-menu"]');

    const loginButton = buttonWrapper.shadowRoot.querySelector('.account-button');
    const newLoginButton = loginButton.cloneNode(1);
    newLoginButton.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        window.location.href = '/pages/wholesale-signup-form'
    });
    loginButton.parentElement.appendChild(newLoginButton);
    loginButton.remove();
})()